import React from 'react';

import { NoScrollController } from '+/utils/NoScrollController';

export const NoScrollContext = React.createContext(new NoScrollController());
